import { ENTITY_TYPES, IContact } from '@sales-center/common'

import { IMoreMenuItem } from '@sales-center/components'
import { SxProps, Theme } from '@mui/material/styles'

export enum CardVariants {
  pestpac = 'pestpac',
  wwm = 'wwm',
  wws = 'wws',
}

export type ContactCardProps = {
  sx?: Record<string, SxProps<Theme> | string | undefined>
  contact: IContact
  isPrimaryContact: boolean
  maxWidth?: string
  variant: CardVariants
  entityId: number
  entityType: ENTITY_TYPES
  canUpdateEntity: boolean
  hideEditOptions?: boolean
  locationType?: 'service' | 'billto' | 'both'
  menuOptions?: IMoreMenuItem[]
}
